<template>
  <div class="rounded p-3" style="background: #e9ecef">
    <div style="max-width: 400px; margin: 0 auto; position: relative">
      <!-- Mobile Phone Frame -->
      <div
        style="
          background: #000;
          border-radius: 30px;
          padding: 15px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
        "
      >
        <div
          style="
            background: #fff;
            border-radius: 20px;
            overflow: hidden;
            position: relative;
          "
        >
          <!-- Status Bar -->
          <div
            style="
              padding: 8px 15px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              font-size: 11px;
            "
          >
            <span>9:30</span>
            <div style="display: flex; gap: 4px">
              <span>📶</span>
              <span>📡</span>
              <span>🔋</span>
            </div>
          </div>

          <!-- Header with Logo -->
          <div
            style="
              padding: 10px 15px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              background: #fff;
            "
          >
            <div style="font-weight: bold; font-size: 18px">StakeToken</div>
            <div style="display: flex; gap: 10px" id="mobileAuthButtons">
              <button
                style="
                  padding: 5px 15px;
                  border: 1px solid #ddd;
                  border-radius: 20px;
                  background: #fff;
                  font-size: 12px;
                "
              >
                Log in
              </button>
              <button
                style="
                  padding: 5px 15px;
                  border: none;
                  border-radius: 20px;
                  background: #0066cc;
                  color: #fff;
                  font-size: 12px;
                "
              >
                Sign up
              </button>
            </div>
          </div>

          <!-- Gray Area for Carousel Banner -->
          <div
            style="
              background: #b8c9d9;
              padding: 15px;
              position: relative;
              min-height: 140px;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            <span
              v-if="!bannerCarousel.previewUrl"
              style="color: #666; font-size: 11px"
              >Carousel Banner Area</span
            >
            <!-- Carousel Banner Overlay for Mobile -->
            <div
              id="mobileCarouselOverlayBM"
              style="
                position: absolute;
                top: 10px;
                left: 10px;
                right: 10px;
                bottom: 10px;
                z-index: 10;
              "
            >
              <img
                v-if="bannerCarousel.previewUrl"
                :src="bannerCarousel.previewUrl"
                alt="Mobile Carousel"
                style="
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  border-radius: 8px;
                "
              />
            </div>
          </div>

          <!-- Navigation Icons -->
          <div
            style="
              padding: 15px;
              background: #fff;
              display: flex;
              justify-content: space-around;
              border-bottom: 1px solid #eee;
            "
          >
            <div style="text-align: center; font-size: 10px">
              <div
                style="
                  width: 40px;
                  height: 40px;
                  background: #ffc107;
                  border-radius: 50%;
                  margin: 0 auto 5px;
                "
              ></div>
              <div>Promos</div>
            </div>
            <div style="text-align: center; font-size: 10px">
              <div
                style="
                  width: 40px;
                  height: 40px;
                  background: #e0e0e0;
                  border-radius: 50%;
                  margin: 0 auto 5px;
                "
              ></div>
              <div>Racing</div>
            </div>
            <div style="text-align: center; font-size: 10px">
              <div
                style="
                  width: 40px;
                  height: 40px;
                  background: #e0e0e0;
                  border-radius: 50%;
                  margin: 0 auto 5px;
                "
              ></div>
              <div>NRL</div>
            </div>
            <div style="text-align: center; font-size: 10px">
              <div
                style="
                  width: 40px;
                  height: 40px;
                  background: #e0e0e0;
                  border-radius: 50%;
                  margin: 0 auto 5px;
                "
              ></div>
              <div>AFL</div>
            </div>
          </div>

          <!-- Content Area -->
          <div style="padding: 15px; background: #fff; min-height: 300px">
            <div
              style="
                font-size: 12px;
                color: #666;
                text-align: center;
                padding: 20px;
              "
              id="mobileMainContentText"
            >
              Main Content Area<br />(Racing Markets, etc.)
            </div>
          </div>

          <!-- Bottom Navigation -->
          <div
            style="
              padding: 10px;
              background: #fff;
              display: flex;
              justify-content: space-around;
              border-top: 1px solid #eee;
              font-size: 10px;
            "
          >
            <div style="text-align: center">Home</div>
            <div style="text-align: center; color: #0066cc; font-weight: bold">
              Racing
            </div>
            <div style="text-align: center">Sports</div>
            <div style="text-align: center">Settings</div>
          </div>
        </div>
      </div>
      <div class="text-muted small text-center mt-2">
        Only Carousel Banner appears on mobile
      </div>
    </div>
  </div>
</template>
<script>
import { objectProp } from "@/helpers/props";
export default {
  props: {
    bannerCarousel: objectProp(),
  },
};
</script>
